import React, { ComponentPropsWithoutRef } from "react";

interface ButtonProps extends ComponentPropsWithoutRef<"button"> {
  buttonStyle?: string | null;
  text: string;
  onClick?: () => void;
}

export default function Button({
  buttonStyle = "btn-primary",
  text,
  onClick,
  ...rest
}: ButtonProps,
) {
  return (
    <button
      type="button"
      className={`btn ${buttonStyle}`}
      onClick={onClick}
      {...rest}
    >
      {text}
    </button>
  );
}
